<template>
  <table class="d-table marg-1-bottom d-table__overview">
    <thead>
    <tr>
      <th><h4>Oversigt</h4></th>
      <th class="is-number"></th>
      <th class="is-number">{{ $t('vue2.assign_users_hours.assigned') }}</th>
      <th class="is-number" v-if="isShowScheduled">{{ $t('vue2.assign_users_hours.scheduled') }}</th>
      <th class="is-number" v-if="isShowScheduled">{{ $t('vue2.assign_users_hours.diff') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ $t('vue2.task_overview.work_hours') }}</td>
      <td class="is-number">
      </td>
      <td class="is-number" :class="{'is-number--calculated': isDateIntervalChanged}"
          :content='tooltipContent'
          v-tippy="{
            animateFill: false,
            animation : 'shift-away',
          onShow: () => isDateIntervalChanged
        }">
        <span class="icon-clock" v-if="isDateIntervalChanged"></span>
        {{ assignedTotalHoursForPeriod }}
      </td>
      <td class="is-number" v-if="isShowScheduled">{{ getUserHoursOverview.actual_total_hours }}</td>
      <td class="is-number" v-if="isShowScheduled" :style="scaleIndicator(diffTotalHoursForPeriod)">
        {{ diffTotalHoursForPeriod }}
      </td>
    </tr>
    <tr>
      <td>Med børn</td>
      <td class="is-number">
      </td>
      <td class="is-number" :class="{'is-number--calculated': isDateIntervalChanged}"
          :content='createTooltip(assignedHoursWithKids)'
          v-tippy="{
            animateFill: false,
            animation : 'shift-away',
          onShow: () => isDateIntervalChanged
        }">
        <span class="icon-clock" v-if="isDateIntervalChanged"></span>
        {{ assignedHoursWithKidsInPeriod }}
      </td>
      <td class="is-number" v-if="isShowScheduled">{{ userActualWithKids }}</td>
      <td class="is-number" v-if="isShowScheduled" :style="scaleIndicator(diffHoursWithKidsForPeriod)">{{ diffHoursWithKidsForPeriod }}</td>
    </tr>
    <tr>
      <td>Uden børn</td>
      <td class="is-number">
      </td>
      <td class="is-number" :class="{'is-number--calculated': isDateIntervalChanged}"
          :content='createTooltip(assignedHoursWithoutKids)'
          v-tippy="{
            animateFill: false,
            animation : 'shift-away',
          onShow: () => isDateIntervalChanged
        }">
        <span class="icon-clock" v-if="isDateIntervalChanged"></span>
        {{ assignedHoursWithoutKidsInPeriod }}
      </td>
      <td class="is-number" v-if="isShowScheduled">{{ userActualWithoutKids }}</td>
      <td class="is-number" v-if="isShowScheduled" :style="scaleIndicator(diffHoursWithoutKidsForPeriod)">{{ diffHoursWithoutKidsForPeriod }}</td>
    </tr>
    <tr>
      <td>Med børn + Uden børn</td>
      <td class="is-number">
      </td>
      <td class="is-number" :class="{'is-number--calculated': isDateIntervalChanged}"
          :content='tooltipContent'
          v-tippy="{
            animateFill: false,
            animation : 'shift-away',
          onShow: () => isDateIntervalChanged
        }">
        <span class="icon-clock" v-if="isDateIntervalChanged"></span>
        {{ assignedTotalHoursForPeriod }}
      </td>
      <td class="is-number" v-if="isShowScheduled">{{ userWithKidsAndWithout }}</td>
      <td class="is-number" v-if="isShowScheduled" :style="scaleIndicator(userDiffWithKidsAndWithout)">
        {{ userDiffWithKidsAndWithout }}
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    isShowScheduled: {
      type: Boolean,
      default: true
    },
    isDateIntervalChanged: {
      type: Boolean,
      default: false
    },
    workDayDates: {},
    assignedTotalHoursForYear: {
      type: Number,
      default: 0
    },
    assignedTotalHoursForPeriod: {
      type: Number,
      default: 0
    },
    diffTotalHoursForPeriod: {
      type: Number,
      default: 0
    },
    userActualHours: {
      type: Object,
      default: () => {
      }
    },
    getUserHoursOverview: {
      type: Object,
      default: () => {
      }
    },
    tooltipContent: {
      type: String,
      default: ''
    },
    numberOfWorkDays: {
      type: Number,
      default: 0
    },
    numberOfWorkDaysInPeriod: {
      type: Number,
      default: 0
    }
  },
  computed: {
    userActualWithKids () {
      const usersWithScheduledHours = this.userActualHours
      if (usersWithScheduledHours && usersWithScheduledHours.actual_with_kids_hours) {
        return this.toFixedIfNecessary(usersWithScheduledHours.actual_with_kids_hours)
      } else {
        return 0
      }
    },
    userActualWithoutKids () {
      const usersWithScheduledHours = this.userActualHours
      if (usersWithScheduledHours && usersWithScheduledHours.actual_without_kids_hours) {
        return this.toFixedIfNecessary(usersWithScheduledHours.actual_without_kids_hours)
      } else {
        return 0
      }
    },
    userWithKidsAndWithout () {
      const sum = (this.userActualWithKids * 1) + (this.userActualWithoutKids * 1)
      return this.toFixedIfNecessary(sum)
    },
    userDiffWithKidsAndWithout () {
      const sum = (this.userActualWithKids * 1) + (this.userActualWithoutKids * 1)
      const diff = this.assignedTotalHoursForPeriod - sum
      return this.toFixedIfNecessary(diff)
    },
    userTasks () {
      return this.$store.state.subjects.userTasks
    },
    assignedHoursWithoutKids () {
      const tasks = this.userTasks.filter(task => task.master_type === 'without_kids')
      const hours = [0]
      tasks.forEach(task => {
        hours.push(task.hours * 1)
      })
      return hours.reduce((acc, n) => acc + n)
    },
    assignedHoursWithoutKidsInPeriod () {
      return this.assignedHoursForPeriod(this.assignedHoursWithoutKids)
    },
    diffHoursWithoutKidsForPeriod () {
      const hoursPerDay = (this.assignedHoursWithoutKids / this.numberOfWorkDays) * 1
      const hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod
      const diff = hoursInThePeriod - this.userActualWithoutKids
      return this.toFixedIfNecessary(diff)
    },
    assignedHoursWithKids () {
      return this.assignedTotalHoursForYear - this.assignedHoursWithoutKids
    },
    assignedHoursWithKidsInPeriod () {
      const hoursPerDay = (this.assignedHoursWithoutKids / this.numberOfWorkDays) * 1
      const assignedHoursWithoutKidsInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod
      const result = this.assignedTotalHoursForPeriod - assignedHoursWithoutKidsInThePeriod
      return this.toFixedIfNecessary(result)
    },
    diffHoursWithKidsForPeriod () {
      const hoursPerDay = (this.assignedHoursWithKids / this.numberOfWorkDays) * 1
      const hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod
      const diff = hoursInThePeriod - this.userActualWithKids
      return this.toFixedIfNecessary(diff)
    }
  },
  methods: {
    createTooltip (sumForYear) {
      const hoursPerDay = sumForYear / this.numberOfWorkDays
      const hoursForPeriod = hoursPerDay * this.numberOfWorkDaysInPeriod
      const hoursPerDayFixed = this.toFixedIfNecessary(hoursPerDay)
      const hoursForPeriodFixed = this.toFixedIfNecessary(hoursForPeriod)
      return `<p><i>Når du vælger et andet datointerval end hele året, kan du her se, hvor mange timer, der skal planlægges for medarbejderen i perioden og i gennemsnit per dag. Udregningen tager højde for institutionens ferie- og helligdage.</i></p><br></p><p><b>Beregning</b></p><p>For året: ${sumForYear} timer / ${this.numberOfWorkDays} dage = ${hoursPerDayFixed} timer pr. dag</p><p>For perioden: ${this.numberOfWorkDaysInPeriod} arbejdsdage * ${hoursPerDayFixed} timer pr. dag = ${hoursForPeriodFixed} timer</p>`
    },
    assignedHoursForPeriod (hours) {
      const hoursPerDay = (hours / this.numberOfWorkDays) * 1
      const hoursInThePeriod = hoursPerDay * this.numberOfWorkDaysInPeriod
      return this.toFixedIfNecessary(hoursInThePeriod)
    },
    toFixedIfNecessary (value) {
      const num = value * 1
      return parseFloat(num).toFixed(2)
    },
    scaleIndicator (diff) {
      let color = 'rgba(62, 207, 142, 0.4)'
      let newDiff = parseFloat(diff)
      let indicatorPercentage = parseFloat(newDiff.toFixed(0))
      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
        indicatorPercentage = '0' + indicatorPercentage
      }
      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
        indicatorPercentage = '0' + (indicatorPercentage * -1)
      }
      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
        indicatorPercentage = indicatorPercentage * -1
      }
      if (newDiff === 0) {
        color = 'transparent'
      }
      if (newDiff < 0) {
        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')'
      }
      if (newDiff < -99) {
        color = 'rgba(250, 86, 90, 1)'
      }
      if (newDiff > 0) {
        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')'
      }
      if (newDiff > 99) {
        color = 'rgba(62, 207, 142, 1)'
      }
      return {'backgroundColor': color}
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table, .subjects-and-tasks {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.is-number {
  text-align: right;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.d-table__overview {
  font-size: 11px;
}

@media only screen and (min-width: 500px) {
  .d-table__overview {
    font-size: 1rem;
  }
}

.d-table__overview tbody tr {
  border: 1px solid #e2e8f0;
}

.d-table__overview tbody tr:nth-child(even) {
  background-color: #f8fafb;
}

.d-table__overview tbody tr td {
  padding: 0.25rem;
}

.d-table__overview tbody tr td:first-child {
  padding: 0.25rem;
}

.d-table__overview tbody tr td:nth-child(4) {
  padding-right: 1rem;
}

.d-table__subjects__user tbody tr:nth-child(even) {
  background-color: #f8fafb;
}

.d-table__subjects__user thead th:first-child,
.d-table__subjects__user tbody td:first-child {
  max-width: 300px;
  width: 20%
}

.d-table tbody td:nth-child(2) {
  width: 50%;
}

.d-table tbody td:nth-child(3),
.d-table tbody td:nth-child(4),
.d-table tbody td:nth-child(5) {
  width: 10%;
}

.is-number--calculated {
  color: var(--purple);
  font-style: italic;
  cursor: help;
}


</style>



// WEBPACK FOOTER //
// UserTasksOverviewKindergarten.vue?2c5a104d